// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const CommPreferenceService = {
    // GetConsentByMessageType determines if it is okay to message a destination address for a particular purpose (MessageType).
    // A definitive answer is guaranteed for a valid request.
    GetConsentByMessageType(fn, req) {
        return fn(`/comm-preference/preference/v1/consent?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // CheckPreference determines if it is okay to message someone.
    // It returns true if the user has not unsubscribed from messages of a certain type from a certain location.
    // DEPRECATED: use "GetConsentByMessageType" instead.
    CheckPreference(fn, req) {
        return fn(`/comm-preference/preference/v1/preference?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetPreference returns a Preference record matching a specific user, location, and communication channel.
    // 
    // Like the "ListConsentByMessageType" call, a populated Preference record is guaranteed in the response of a valid request
    // for every opt-outable channel program - the same Program list returned from a call to "ListPrograms()".
    // WARNING: Standard auth will soon be required for this endpoint. For the legacy SMS communication preferences management
    // page, call "GetLegacySMSPreference()" instead. At some point, that endpoint will be deprecated when
    // the legacy SMS communication preferences management page is shut down - in favor of the newer style token-based
    // "GetPreferenceByToken()" call.
    GetPreference(fn, req) {
        try {
            fm.validateUrlParam(req["userChannelAddress"], "userChannelAddress");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/comm-preference/preference/v1/preferences/${req["userChannelAddress"]}?${fm.renderURLSearchParams(req, ["userChannelAddress"])}`, { method: "GET" });
    },
    // GetLegacySMSPreference returns a Preference record for a specific Legacy SMS user phone number and location.
    // Like the "ListConsentByMessageType" call, a populated Legacy SMS Preference record is guaranteed in the response
    // of a valid request for every opt-outable program - the same Program list returned
    // from a call to "ListPrograms()" (for legacy SMS).
    GetLegacySMSPreference(fn, req) {
        try {
            fm.validateUrlParam(req["phoneNumber"], "phoneNumber");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/comm-preference/preference/v1/preferences-sms-legacy/${req["phoneNumber"]}?${fm.renderURLSearchParams(req, ["phoneNumber"])}`, { method: "GET" });
    },
    // GetPreferenceByToken returns a Preference record matching a specific user, location, and communication channel,
    // as specified by a token.
    // The record is guaranteed to represent consent for every opt-outable Program returned from ListPrograms,
    // even if a hard record does not currently exist.
    GetPreferenceByToken(fn, req) {
        try {
            fm.validateUrlParam(req["token"], "token");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/comm-preference/preference/v1/pub/preferences/${req["token"]}?${fm.renderURLSearchParams(req, ["token"])}`, { method: "GET" });
    },
    // GetProgramSlugByMessageType returns the program slug for a given message type.
    // WARNING: While this call is not yet deprecated, it likely will be in the near future once the SMS Platform
    // completes the transition to using the newer MessageType enum.
    GetProgramSlugByMessageType(fn, req) {
        return fn(`/comm-preference/preference/v1/program-slug-by-message-type?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListPrograms returns a complete list of opt-outable programs for the specified channel.
    // A valid channel is required.
    // NOTE: This endpoint returns programs in a channel-agnostic format, meaning the
    // program slug ids are raw strings rather than enums. This matches how they are
    // stored in the database. More specifically, if the request Channel is "SMS" and "use_legacy_sms" is true,
    // then program slug ids are the legacy SMS slug id values (they do not represent enums). Other than that,
    // returned program slug id values represent the integer string of the Channel Program enum such as "1" or "2".
    ListPrograms(fn, req) {
        return fn(`/comm-preference/preference/v1/programs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListSMSAndVoiceProgramInfo returns a list of SMS and Voice programs and their descriptions.
    // Program slug ids are respective SMS and Voice enums.
    ListSMSAndVoiceProgramInfo(fn, req) {
        return fn(`/comm-preference/preference/v1/info/sms-and-voice-programs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListSMSProgramInfo returns a list of SMS programs and their descriptions.
    // Program slug ids are SMS enums.
    ListSMSProgramInfo(fn, req) {
        return fn(`/comm-preference/preference/v1/info/sms-programs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListVoiceProgramInfo returns a list of Voice programs and their descriptions.
    // Program slug ids are enums.
    ListVoiceProgramInfo(fn, req) {
        return fn(`/comm-preference/preference/v1/info/voice-programs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListEmailProgramInfo returns a list of email programs and their descriptions.
    // Program slug ids are enums.
    ListEmailProgramInfo(fn, req) {
        return fn(`/comm-preference/preference/v1/info/email-programs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListWeaveEmailProgramInfo returns a list of Weave email programs and their descriptions.
    // Program slug ids are enums.
    ListWeaveEmailProgramInfo(fn, req) {
        return fn(`/comm-preference/preference/v1/info/weave-email-programs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListWeaveEmailUpdateProgramInfo returns a list of Weave email update programs and their descriptions.
    // Program slug ids are enums.
    ListWeaveEmailUpdateProgramInfo(fn, req) {
        return fn(`/comm-preference/preference/v1/info/weave-email-update-programs?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // DEPRECATED: Use "GenerateManagementUrls" instead.
    GenerateManagementUrl(fn, req) {
        return fn(`/comm-preference/preference/v1/management-url?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GenerateManagementUrls returns URLs for managing a user's communication preferences for a specific location and
    // channel. Besides a general management URL, if a messaging type is specified in the request, a one-click unsubscribe
    // URL will also be returned which immediately unsubscribes the user from the program associated with that messaging
    // type.
    GenerateManagementUrls(fn, req) {
        return fn(`/comm-preference/preference/v1/management-urls?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
